import { render, staticRenderFns } from "./UiInputHtmlTiptap.vue?vue&type=template&id=660683c3&"
import script from "./UiInputHtmlTiptap.vue?vue&type=script&lang=js&"
export * from "./UiInputHtmlTiptap.vue?vue&type=script&lang=js&"
import style0 from "./UiInputHtmlTiptap.vue?vue&type=style&index=0&id=660683c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports